import data from './data.json';

const processData = () => {
  return data;
};

export default processData;
